import React from "react";
import BarChart from "./BarChart";
import GroupedBarChart from "./GroupedBarChart";

interface TemplateTasasProps {
    chartLabels: string[][];
    chartData: (number[] | { label: string; data: number[]; backgroundColor: string }[])[];
    chartTitle: string[];
    tipoGrafica?: string[];
    onSetChatInput?: (text: string) => void;
}

const TemplateTasas: React.FC<TemplateTasasProps> = ({
    chartLabels,
    chartData,
    chartTitle,
    tipoGrafica,
    onSetChatInput,
}) => {
    const chartColors = ["#00A4E4", "#50C878", "#fb5607", "#FF5733", "#9B59B6", "#F39C12"];

    const handleBarClick = (label: string, idx: number) => {
        const title = chartTitle[idx] || "";
        let text = "";
        if (title.toLowerCase().includes("centro")) {
            text = "template tasas de cada titulacion de " + label;
        } else if (title.toLowerCase().includes("titulacion") || title.toLowerCase().includes("titulación")) {
            text = "template tasas de cada asignatura de la titulación de " + label;
        }
        if (onSetChatInput && text) {
            onSetChatInput(text);
        }
    };

    const renderChart = (idx: number) => {
        const labels = chartLabels[idx] || [];
        let dataValue = chartData[idx] || [];
        const title = chartTitle[idx] || "Gráfica de respuesta";
        const tipo = tipoGrafica && tipoGrafica[idx] ? tipoGrafica[idx] : "Barra";

        const isPercentage = title.toLowerCase().includes("tasa");

        if (!Array.isArray(dataValue)) {
            dataValue = [];
        }

        if (
            tipo === "GroupedBar" &&
            Array.isArray(dataValue) &&
            dataValue.length > 0 &&
            typeof dataValue[0] === "object" &&
            dataValue[0] !== null &&
            "label" in dataValue[0]
        ) {
            const newDatasets = (dataValue as { label: string; data: number[]; backgroundColor: string }[]).map(ds => ({
                ...ds,
                data: ds.data.map(v => (typeof v === "number" && v <= 1 ? Number((v * 100).toFixed(2)) : v)),
            }));
            
            return <GroupedBarChart
                labels={labels}
                datasets={newDatasets}
                title={title}
                onBarClick={(label: string) => handleBarClick(label, idx)}
            />;
        } else {
            const newData = (dataValue as number[]).map(v => (typeof v === "number" && v < 1 ? Number((v * 100).toFixed(2)) : v));
            return (
                <BarChart
                    labels={labels}
                    data={newData}
                    title={title}
                    barColor={chartColors[idx % chartColors.length]}
                    isPercentage={isPercentage}
                />
            );
        }
    };

    const chunkArray = <T,>(arr: T[], chunkSize: number): T[][] => {
        const result = [];
        for (let i = 0; i < arr.length; i += chunkSize) {
            result.push(arr.slice(i, i + chunkSize));
        }
        return result;
    };

    const chunks = chunkArray(chartLabels, 2);

    return (
        <div
            className="template-charts-tasas"
            style={{ overflowY: "auto", maxHeight: "700px" }}
        >
            {chunks.map((chunk, rowIndex) => (
                <div className="charts-row-tasas" key={rowIndex}>
                    {chunk.map((_, colIndex) => {
                        const chartIndex = rowIndex * 2 + colIndex;
                        return (
                            <div className="chart-container-tasas" key={chartIndex}>
                                {renderChart(chartIndex)}
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

export default TemplateTasas;